<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <!--<el-button style='float:left;' size='small' icon="el-icon-check" @click.native="closeForm">{{lang.butReturn}}</el-button>-->
			<el-form :inline="true">        
				<el-form-item>
					<el-input v-model="searchFilter" placeholder="Search"  @change='startSearch'></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="startSearch">{{lang.butSearch}}</el-button>
					<el-button type="" size='small' v-on:click="searchFilter='';getRecords();">C</el-button>
				</el-form-item>        
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="niceDate" label="Created" width="150" sortable></el-table-column>
      <el-table-column prop="file" label="Zip Name" min-width="300" sortable></el-table-column>
      <el-table-column prop='nskProcessed' label='Imported from NSK' min-width='230' sortable></el-table-column>
      <el-table-column prop='nskCount' label='NSK#' width='70'></el-table-column>
      <el-table-column prop='sqsCount' label='SQS#' width='70'></el-table-column>

      <el-table-column prop='sqsProcessed' label='Saved in Jits' min-width='230'  sortable></el-table-column>
      <!--
      <el-table-column prop='dbAddCount' label='SQL Add' sortable></el-table-column>
      <el-table-column prop='dbModCount' label='SQL Mod' sortable></el-table-column>
      <el-table-column prop='dbDelCount' label='SQL Deleted' sortable></el-table-column>
      <el-table-column prop='dbSkipCount' label='SQL Skipped' sortable></el-table-column>
      <el-table-column prop='dbActCount' label='SQL Activated' sortable></el-table-column>
      <el-table-column prop="totError" label="Total Error" min-width="90" sortable></el-table-column>
      -->
      <el-table-column label="" width="50" fixed='right'>

				<template slot-scope="scope">
					<el-button type='success' size="small" icon="el-icon-view"  @click="handleView(scope.row)"></el-button>
					<!--<el-button disabled type="danger" size="small" icon="el-icon-delete"  @click="handleDel(scope.row)"></el-button>-->
				</template>
			</el-table-column>
    
		</el-table>
		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :page-sizes="[10, 15, 25, 50, 100]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
      </el-col>
    
		<!--Wijzig record -->
    <el-dialog title="Show Load Details" :visible.sync="editFormVisible" width='70%'
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="140px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card"  @tab-click="clickTab"  v-model='currentTab'>
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane name='MAIN'>
            <span slot='label'><i class='el-icon-date'></i> Load Status</span>
           <div style='font-size:12px;color:white;margin:0 0 7px 0;padding:5px;width:100%;background:#999'><center>Imported from NSK</center></div>
            <el-form-item label="Imported : ">
              <el-input disabled v-model="editForm['niceDate']"></el-input>
            </el-form-item>
            <el-form-item label="Zip File : ">
              <el-input disabled v-model="editForm['file']"></el-input>
            </el-form-item>
            <el-form-item label="Zip Processed : ">
              <el-input disabled v-model="editForm['nskProcessed']"></el-input>
            </el-form-item>
            <el-form-item label="Records/Sqs# : ">              
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['nskCount']"></el-input>
              <el-input style='width:20%' disabled v-model="editForm['sqsCount']"></el-input>
            </el-form-item>
            <div style='font-size:12px;color:white;margin:7 0 7px 0;padding:5px;width:100%;background:#999'><center>Saved in Jits DB</center></div>
            
            <el-form-item label="Saved On : ">
              <el-input disabled v-model="editForm['sqsProcessed']"></el-input>
            </el-form-item>

            <el-form-item label="Add/Mod/Del/Skip : ">              
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['dbAddCount']"></el-input>
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['dbModCount']"></el-input>
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['dbDelCount']"></el-input>
              <el-input style='width:20%' disabled v-model="editForm['dbSkipCount']"></el-input>
            </el-form-item>
            <!--       
            <el-form-item label="Added / Modified : ">              
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['dbAddCount']"></el-input>
              <el-input style='width:20%' disabled v-model="editForm['dbModCount']"></el-input>
            </el-form-item>
            <el-form-item label="Deleted / Skipped : ">              
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['dbDelCount']"></el-input>
              <el-input style='width:20%' disabled v-model="editForm['dbSkipCount']"></el-input>
            </el-form-item>
            -->
            <el-form-item label="Unique Dossiers : ">              
              <el-input style='width:20%;margin-right:10px' disabled v-model="editForm['dossierCount']"></el-input> 
              <!--<el-input style='width:20%' disabled v-model="editForm['dbActCount']"></el-input>-->
            </el-form-item>  
            <el-form-item label="Has Errors : ">              
       			   <el-switch disabled xstyle='width:20%' v-model="editForm['hasErrors']"></el-switch>
            </el-form-item>  
            
  				</el-tab-pane>

	        <el-tab-pane name='DOSSIERS' v-loading="dataLoading" >
            <span slot='label'><i class='el-icon-date'></i> Dossiers</span>
            <el-input readonly type='textarea' rows='20' cols='100' style='font-family:system;font-size:12px' v-model="loadDossiers">  </el-input>             
  				</el-tab-pane>
	        <el-tab-pane name='ERRORS' v-loading="dataLoading" >
            <span slot='label'><i class='el-icon-date'></i> Errors</span>
            <el-input readonly type='textarea' rows='20' style='font-family:system;font-size:12px' v-model="loadErrors">  </el-input>             
  				</el-tab-pane>
  			</el-tabs>
			</el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' type="primary" icon="el-icon-edit"  @click.native="editFormVisible=false" :loading="editLoading">Close</el-button>
			</div>
		</el-dialog>
   </section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/dbc/dbcload';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"DBC"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,

				editTitle   : "",
				editMode    : "",
				APICode     : "DbcLoad",
				mainFunc    : "DbcLoad",
				mainSubject : "file",
        mainKey     : "date",
				mainKeyDesc : "date",
        searchFilter: '',				
        content: [],
				counter: {},
				related: [],
				currentPage: 1,
				mainTotal: 0,
        marker: "",
        loadErrors: "",
        loadDossiers: "",
        currentTab: 'MAIN',
        dataLoading: false,
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					anvrid: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {
 	  	closeForm: function () {
         this.selectorVisible = false;
	  	   //this.$router.push({name: 'Employees',params: this.stack});
    	},


		  startSearch: function() {
        this.currentPage = 1;
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {
				let parg = {};
        parg.Params = {};
        parg.Params.search = this.searchFilter;  /* of search */

				this.listLoading = true;
				
				api.getListPage(parg).then((res) => {						
          util.processMainResults(res);
          this.codes = util.codes;          
          this.mainTotal = util.payload[this.APICode].length;         

         
          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });


			},
			

      clickTab: function(tab,event) {
        if (this.currentTab == "ERRORS") this.openTabErrors("ERRORS");
        if (this.currentTab == "DOSSIERS") this.openTabDossiers("DOSSIERS");
      },

      openTabErrors(name) {
        let parg = {};
        parg.Params = {};
        parg.Params.marker = this.marker;

        this.dataLoading = true;
        api.execute('errors',parg).then((res) => {		
          var d = res.data;
            
            this.loadErrors = d.payload.errors;
            this.dataLoading = false;
          })
        .catch((error) => {
          util.serverError(this);
        });
      },

      openTabDossiers(name) {
        let parg = {};
        parg.Params = {};
        parg.Params.marker = this.marker;

        this.dataLoading = true;
        api.execute('dossiers',parg).then((res) => {		
          var d = res.data;
            
            this.loadDossiers = d.payload.dossiers;
            this.dataLoading = false;
      })
        .catch((error) => {
          util.serverError(this);
        });
      },


			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;

				  let parg = {};
          parg.Record = row;

				  api.removeRecord(parg).then((res) => {
						this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKey])			  			              
				  	});
						this.getRecords();
					});

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleView: function (row) {
        this.editMode = "save";
				this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKey]);
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
        //this.$nextTick(() => this.$refs.firstEdit.focus());
        this.marker = row.date;
        this.loaderrors = "";
        this.loadDossiers = "";
        this.currentTab = "MAIN";
			},
			
			
			// Toon nieuwe interface
			handleAdd: function () {
				this.editMode = "add";
				this.editTitle = text.getText("addM",this.mainSubject);
				this.editFormVisible = true;
				this.editForm = {};
        //this.$nextTick(() => this.$refs.firstAdd.focus());
			},

			// uitgeven
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						
            let parg = {};
            parg.Params = {};
            parg.Record = Object.assign({}, this.editForm);

            if (this.editMode == "add") 
            {
              parg.Action = "add";
							api.addRecord(parg).then((res) => {
                if (res.data.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.name)});
                else this.$notify({title: "Error",type: 'error',message: res.data.header.message});
		    				this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
              parg.Action = "save";
							api.saveRecord(parg).then((res) => {		  					
                if (res.data.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.name)});
                else this.$notify({title: "Error",type: 'error',message: res.data.header.message});
						    this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},

		},

		mounted() {
      
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      if (this.$route.params) {
        this.stack = this.$route.params;
      }
      

			this.related = settings.getRelated();
			this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// dbcload.vue?41634f94